import React, { createContext, useContext, useState, useCallback } from 'react';

interface TimeTrackingContextType {
  refreshTrigger: number;
  triggerRefresh: () => void;
}

const TimeTrackingContext = createContext<TimeTrackingContextType | undefined>(undefined);

export const TimeTrackingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return (
    <TimeTrackingContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </TimeTrackingContext.Provider>
  );
};

export const useTimeTrackingRefresh = () => {
  const context = useContext(TimeTrackingContext);
  if (context === undefined) {
    throw new Error('useTimeTrackingRefresh must be used within a TimeTrackingProvider');
  }
  return context;
};
